export const SET_ALL = 'SET_ALL';
export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_LOADING = 'SET_LOADING';
